import React, { FC } from 'react';

import GeneralLayout from 'core/react/layout/GeneralLayout';
import { TepDevicesManagement } from 'components/organisms/tep/devices';

export const TepDevicesManagementPage: FC = () => (
  <GeneralLayout>
    <TepDevicesManagement />
  </GeneralLayout>
);
